import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import {useSelector} from 'react-redux';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {useRumCounter} from 'client/common/utils/rum';
import {tld} from 'client/common/utils/tld';

import {Chat} from 'client/common/components/chat';
import Header, {headerMeaningfulSelector} from 'client/common/components/header2';
import Modal from 'client/common/components/modal';
import Notifications from 'client/common/components/notifications';
import CountryModal from 'client/common/components/country-modal/country-modal';

import {getTestBuckets} from 'client/common/store/selectors/user';
import {getExperiments} from 'client/common/store/selectors/experiments';

import './choose-payment-data.css';

const i18n = I18N.surveyCreate;
const b = b_.with('choose-payment-data');

// редиректим на retpath или на список опросов в случае ошибок/опечаток
function getRedirectPathFromUrl(url: Location['href']) {
    const RETPATH_PARAM_NAME = 'retpath';
    const currentUrl = new URL(url);
    const retpath = currentUrl.searchParams.get(RETPATH_PARAM_NAME);

    currentUrl.pathname = retpath ? decodeURIComponent(retpath) : '/quicksurvey';
    currentUrl.searchParams.delete(RETPATH_PARAM_NAME);

    return currentUrl.toString();
}

function handlePaymentDataSelect() {
    location.href = getRedirectPathFromUrl(location.href);
}

function ChooseModal({testBuckets}: {testBuckets: string[]}) {
    useRumCounter({
        page: 'quicksurvey.choose-payment-data',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets
    });

    return (
        <div className={b()}>
            <div className={b('modal-wrapper')}>
                <CountryModal onDone={() => handlePaymentDataSelect()} tld={tld} />
            </div>
        </div>
    );
}

export default function ChoosePaymentDataPage() {
    const experiments = useSelector(getExperiments);
    const testBuckets = useSelector(getTestBuckets);

    return (
        <Fragment>
            <Helmet>
                <title>{i18n.pageTitle}</title>
                <meta property='og:url' content='https://surveys.yandex.ru/quicksurvey' />
            </Helmet>
            <Header className={b('header')} />
            <ChooseModal testBuckets={testBuckets} />
            <Chat
                experiments={experiments}
                from={`choose currency and country ${tld.toUpperCase()}`}
            />
            <Notifications />
            <Modal />
        </Fragment>
    );
}
